import { Box, Button, createStyles, Link, makeStyles, Typography, CircularProgress, Snackbar } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { useStaticQuery, graphql } from 'gatsby'
import React, { useState } from 'react'
import OtpInput from 'react-otp-input'
import { updatePhoneNumber, verifyPhone } from '../../api/subscription'

const useStyles = makeStyles(({palette, spacing})=>createStyles({
  otpContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },
  otpInput: {
    width: '50px !important',
    marginLeft: spacing(1.5),
    marginRight: spacing(1.5),
    height: 50,
    borderStyle: 'solid',
    borderColor: palette.grey[400],
    borderWidth: 1,
    borderRadius: 4,
    outline: 'none'
  },
  otpFocus:{
    borderColor: palette.primary.main
  },
  otpError: {
    borderColor: palette.error.main
  }
}))

interface Props{
  onNext: (verifiedNumber:boolean) => void
  onReenterPhone: () => void
}


export const OtpValidation: React.FC<Props> = ({onNext, onReenterPhone}) => {
  const classes = useStyles()
  const [otp, setOtp] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const phone = localStorage.getItem('clientPhoneNumber') || ''
  const subscriptionId = localStorage.getItem('clientSubscriptionId') || ''
  const validateOtp = async (code: string) => {
    try {
      setLoading(true)
      const response = await verifyPhone({phone_verification_key: code, client_phone: phone})
      if(response.ok){
        const json = await response.json()
        if(json.status === 'Phone number verified'){
          setLoading(false)
          return onNext(true)
        }
      }
      setError(true)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.error('Otp Verification:', error)
    }
  }
  const handleChange = (value:string) => {
    setError(false)
    setOtp(value)
    if(value.length === 4){
      validateOtp(value)
    }
  }
  const data = useStaticQuery(graphql`
  query {
    file(relativePath: {eq: "message_sent.svg"}) {
      relativePath
      publicURL
    }
  }`)

  const handleSendAgain = async () => {
    try {
      setLoading(true)
      const response = await updatePhoneNumber({client_phone: phone, subscription_id: subscriptionId})
      if(response.ok){
        const json = await response.json()
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
    }
  }
  

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Typography align="center" variant="subtitle1">
        You’re almost there! Input your code to connect with your trainer.
      </Typography>
      <Box mt={1} />
        <img
          width="108px"
          height="65px"
          src={data.file.publicURL}
          alt=""
        />
      <Box mt={3} />
      <Typography variant="subtitle1">
        We texted a code to +{phone}
      </Typography>
      <Typography variant="body2">
        This code will be valid for 4 minutes.
      </Typography>
      <Box mt={2} />
      <Typography>
        Sent the code to the wrong phone number?
      </Typography>
      <Link onClick={onReenterPhone} underline="always" color="primary">
        Re-enter your phone number
      </Link>
      <Box mt={3} />
     {loading? <CircularProgress />: <OtpInput
        value={otp}
        onChange={handleChange}
        shouldAutoFocus
        isInputNum
        numInputs={4}
        hasErrored={error}
        containerStyle={classes.otpContainer}
        errorStyle={classes.otpError}
        inputStyle={classes.otpInput}
        focusStyle={classes.otpFocus}
      />}
      <Box mt={3} />
      <Typography variant="body2">
        Didn’t receive the code?{' '}
        <Link onClick={handleSendAgain} underline="always" color="primary">
          Send code again
        </Link>
      </Typography>
      <Snackbar
        open={error}
        autoHideDuration={6000}
        onClose={() => setError(false)}
      >
        <Alert onClose={() => setError(false)} severity="error">
        Incorrect otp code. Please check if that’s the right one and try again.
        </Alert>
      </Snackbar>
    </Box>
  )
}
